import { useEffect, useMemo, useRef, useState } from "react";
import selectDrodownIcon from '../assets/images/selectDropdownicon.svg'

export default function MultiSelectSearchDropdown({hasMappedOpt, options, labelKey, valKey,value,handleValuesChange,isMulti=true,
  placeHolder="",
  searchFliedPlaceHolder="Type To Search..."
 }) {
  const [selected, setSelected] = useState(value||[]);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [dropUp, setDropUp] = useState(false);

  const dropdownRef = useRef(null);
  const headerRef = useRef(null);

  useEffect(()=>{
    setSelected(value||[])
  },[value])

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const handleToggle = () => {
    if (!open && headerRef.current) {
      const rect = headerRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const dropdownHeight = 360; // search + options max height
      setDropUp(spaceBelow < dropdownHeight);
    }
    setOpen((prev) => !prev);
  };
const filteredOptions = useMemo(() => {
  if (hasMappedOpt) return options;

  return options.filter((item) =>
    item?.[labelKey]
      ?.toLowerCase()
      ?.includes(search.toLowerCase())
  );
}, [hasMappedOpt, options, search, labelKey]);

console.log(filteredOptions,hasMappedOpt);


  const handleSelect = (item,data) => {
    if (selected.includes(item)) {

      let filt = selected.filter((s) => s != item)

      handleValuesChange(filt,data);
    } else {

      let val = isMulti ? [...selected, item] : [item]

      handleValuesChange( val,data);
    }
  };

  let selectedArr = useMemo(()=>{
    const norm = (v) => v == null ? "" : String(v).trim()
    let arr = []
    selected?.forEach((s)=>{
      let obj = options.find((o)=>norm(o[valKey]) === norm(s))
      if(obj) arr.push(obj[labelKey])
    })
    return arr
  },[selected, options, valKey, labelKey])

  return (
    <div
      ref={dropdownRef}
      style={{
        // width: "700px",
        position: "relative",
        fontFamily: "sans-serif",
      }}
    >
      {/* Dropdown Header */}
      <div
        ref={headerRef}
        onClick={handleToggle}
        style={{
          border: "1px solid #dcdfe4",
          borderRadius: "8px",
          minHeight: "36px",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "8px",
          padding: "8px 12px",
          background: "#fff",
          cursor: "pointer",
        }}
      >
        {selectedArr.length? selectedArr.map((item) => (
          <div
            key={item[valKey]}
            style={{
              background: isMulti?"#eef2f7":"",
              padding: "2px 5px",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "11px",
            }}
          >
            {item}
            {
              isMulti&&
            
            <span
              onClick={(e) => { e.stopPropagation();

                let filt = options.filter((s) => s[labelKey] == item)

                handleSelect(filt[0][valKey],filt); 
              
              }}
              style={{ cursor: "pointer", fontWeight: "bold" }}
            >
              ×
            </span>
}
          </div>
        )):<span>{placeHolder}</span>}
        <div style={{ marginLeft: "auto" }}>
        <svg height="12" width="12" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-tj5bde-Svg"><path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
          
        </div>
      </div>

      {/* Dropdown */}
      {open && (
        <div
          
          className="dropdown-menu-custom"
        >
          {/* Search */}

          <div style={{ borderBottom: "1px solid #e5e7eb", padding: "12px" }}>
            <input
              type="text"
              placeholder={searchFliedPlaceHolder}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ width: "100%", border: "none", outline: "none", fontSize: "15px" }}
            />
          </div>

          {/* Options */}
          <div style={{ maxHeight: "300px", overflowY: "auto", padding: "6px" }}>
            {filteredOptions.map((item,index) => {
              const checked = selected.includes(item[valKey]);


              return (
                <label
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "2px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    background: checked ? "#f3f4f6" : "transparent",
                  }}
                  onClick={()=>{

                    handleSelect(item[valKey],item)
                  if(!isMulti){
                      setOpen(false)
                    }

                  }
                  
                  }
                  className="text-small interRegular"
                >
                  {
                    isMulti&&
                  <input type="checkbox" checked={checked} onChange={() => {
                    
                    handleSelect(item[valKey],item)}} />
                  }
                  <span>{item[labelKey]}</span>
                </label>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}